import React from 'react';
import {
  BlogsImage,
  BlogsDetails,
  BlogsImageContainer,
  BlogsLive,
  BlogsName,
  Blogs,
  LinkWrapper,
  LiveIcon,
  BlogsWrapper,
} from '../styles/Blogs.styled';

const BlogsComponent = ({ img, title, url, hasLink }) => {
  return (
    <BlogsWrapper hasLink={hasLink}>
      <Blogs hasLink={hasLink}>
        <BlogsImageContainer
          href={url}
          hasLink={hasLink}
          target="_blank"
          rel="noopener noreferrer"
        >
          <BlogsImage src={img} />
        </BlogsImageContainer>
        <BlogsDetails>
          <BlogsName>{title}</BlogsName>
          <LinkWrapper hasLink={hasLink}>
            <BlogsLive
              href={url}
              hasLink={hasLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              View Blog <LiveIcon />
            </BlogsLive>
          </LinkWrapper>
        </BlogsDetails>
      </Blogs>
    </BlogsWrapper>
  );
};

export default BlogsComponent;
